import React from "react";

function Footer(props) {
  return (
    <footer>
      <div className="container-fluid">
        <div className="row">
          <button className="btn btn-success" onClick={props.refreshAllData}>
            Click here to refresh listings (Last Refreshed: {props.refreshedOn})
          </button>
        </div>
        <div className="row">
          <div className="col col-12 p-3">
            <h6>References for Aquascaping: </h6>
            <p className="text-listing">
              <a
                href="https://www.allpondsolutions.co.uk/"
                target="_blank"
                rel="noreferrer"
              >
                All Ponds Solutions (UK)
              </a>{" "}
              |{" "}
              <a
                href="https://tropica.com/en/inspiration/"
                target="_blank"
                rel="noreferrer"
              >
                Tropica Plants
              </a>
            </p>
            <hr></hr>
            <h6>
              Developed by:{" "}
              <a href="https://linkedin.com/in/haryatihassan">Haryati Hassan</a>
            </h6>
            <p>
              <span className="text-listing">
                A MERN full-stack hobby project (Github:{" "}
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://github.com/haryati75"
                >
                  haryati75
                </a>
                ). Use of the web app is for learning and demo purpose only.{" "}
              </span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
